import { VersionStates } from '@/components/common/Providers/GraphqlProvider/generated';

export const versionPageLabels: Record<VersionStates, string> = {
  [VersionStates.Active]: 'Activa',
  [VersionStates.Draft]: 'Borrador',
  [VersionStates.Inactive]: 'Version inactiva',
  [VersionStates.Published]: 'Publicada',
};
